export enum STAFF_TICKETS_TABS {
    MY_TICKETS = 'my',
    ALL_OPEN_TICKETS = 'all',
    COMPLETED_TICKETS = 'completed',
}

export enum TICKET_MESSAGE_TYPES {
    TICKET_INTERNAL_NOTE = 'ticket_internal_note',
    TICKET_MESSAGE = 'ticket_message',
}

export interface TicketChatNote {
    title: string;
}

export interface TicketMessage {
    text: string;
    conversationId: number;
    type?: string;
}

export interface SortingOption {
    title: string;
    action: string;
}
